// @ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface SaveMenuPlanRequest {
  userid: string;
  fromdate: string;
  todate: string;
  siteidlist: number[];
  cafeidlist: number[]; // Added cafeidlist
  isallsite: boolean; // Added isallsite
  isallcafe: boolean; // Added isallcafe
  savemenudetails: MenuDetail[];
}

interface MenuDetail {
  menudetailid: number;
  menuplanid: number;
  dishcategoryid: number; // This should be dynamically assigned
  plandate: string;
  daypartid: number; // Assuming this is needed, set according to your logic
  isexcluded: boolean;
  dishidlist: number[];
  foodprogramid: number; // Assuming you will assign this
  comboname: string; // Added placeholder
  itemidlist: number[]; // Assuming this is needed
}

interface InitialState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: InitialState = {
  loading: false,
  error: null,
  success: false,
};

// Async thunk to save menu plan
export const saveMenuPlan = createAsyncThunk(
  'menuPlan/saveMenuPlan',
  async (payload: SaveMenuPlanRequest) => {
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/InitiateMenuPlan/SaveInitiateMenuPlan`, 
        payload
      );
      
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to save menu plan');
      }

      return response.data; 

    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to save menu plan');
    }
  }
);

const initiateMenuPlanSlice = createSlice({
  name: 'initiateMenuPlan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveMenuPlan.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(saveMenuPlan.fulfilled, (state) => {
        state.loading = false;
        state.success = true; // Indicate success
      })
      .addCase(saveMenuPlan.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.error.message || 'Failed to save menu plan';
      });
  },
});

export default initiateMenuPlanSlice.reducer;
